// extracted by mini-css-extract-plugin
export default {"container":"style__container--J6waZ","embed":"style__embed--U2a0x","content":"style__content--GSg1L"};